import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

const campaignSource = [
  { code: 'all', label: 'All' },
  { code: 'total', label: 'Total' },
  { code: 'app', label: 'Source(App)' },
  { code: 'organic', label: 'Organic' },
  { code: 'ads', label: 'Ads' },
  { code: 'ads25', label: 'Ads 2.5' },
  { code: 'ads30', label: 'Ads 3.0' },
  { code: 'meta', label: 'Meta' },
  { code: 'metavo', label: 'Meta VO' },
  { code: 'unity', label: 'Unity' },
  { code: 'unity30', label: 'Unity 3.0' },
  { code: 'tiktok', label: 'Tiktok' },
  { code: 'apple', label: 'Apple Ads' },
]

const SourceSelect = ({ value, onValueChange }) => {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Select source" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Select Source</SelectLabel>
          {campaignSource.map((source) => (
            <SelectItem key={source.code} value={source.code}>
              {source.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}

export default SourceSelect
